'use client';
import React from 'react';
import { motion } from 'motion/react';
import { cn } from 'lib/utils';
import { type ResourceGridChildProps } from './index';
import ResourceCard from './ResourceCard';
import ResourceGridFooterLinks from './ResourceGridFooterLinks';

const ResourceGridFull = ({
  sections = [],
  activeSection,
  showToggle,
  toggleId,
}: ResourceGridChildProps) => {
  // If no sections or no active section, return null
  if (!sections || sections.length === 0) {
    return null;
  }

  return (
    <div className="max-lg:hidden relative z-2">
      <div className="relative">
        {sections.map((section, sectionIndex) => {
          const isActive = showToggle
            ? sectionIndex === activeSection
            : sectionIndex === 0;
          const shouldRender = showToggle ? true : sectionIndex === 0;

          if (!shouldRender) return null;

          return (
            <motion.div
              key={sectionIndex}
              initial={false}
              animate={{
                x: showToggle ? `${(sectionIndex - activeSection) * 100}%` : 0,
                opacity: isActive ? 1 : 0,
              }}
              transition={{
                duration: 0.4,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              className={cn(
                'w-full',
                showToggle && sectionIndex !== activeSection
                  ? 'absolute inset-0 pointer-events-none'
                  : 'relative'
              )}
              role={showToggle ? 'tabpanel' : undefined}
              id={showToggle ? `${toggleId}-panel-${sectionIndex}` : undefined}
              aria-labelledby={
                showToggle ? `${toggleId}-tab-${sectionIndex}` : undefined
              }
              tabIndex={showToggle && isActive ? 0 : undefined}
              aria-hidden={showToggle ? !isActive : false}
              inert={showToggle && !isActive ? true : undefined}
            >
              <div
                className={cn('grid grid-cols-2 gap-6', {
                  'xl:grid-cols-3': section.columns === 3,
                })}
              >
                {section.items.slice(0, 6).map((item, index) => (
                  <ResourceCard
                    key={index}
                    layout={section.itemsLayout}
                    {...item}
                  />
                ))}
              </div>

              <ResourceGridFooterLinks links={section.footerLinks} />
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ResourceGridFull;
